import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { GetPolicyResponse } from '~/services/policy';
import {
  Analytics,
  AnalyticsQuoteIdType,
  AnalyticsRetrieveQuote,
  AnalyticsSessionTimeout,
} from '~/types/analytics';

const initialState: Analytics = {
  route: {
    path: '',
  },
  goalIdentifiers: {
    quoteStartId: '',
    indicativeQuoteId: '',
    quoteCompleteId: '',
    buyCompleteId: '',
    renewalPaymentId: '',
  },
  retrieveQuote: {
    reachedPayment: false,
    retrieveQuoteId: '',
  },
  sessionTimeout: {
    sessionExtended: 0,
  },
};

export const trackAnalyticsSlice = createSlice({
  name: 'analytics',
  initialState,
  reducers: {
    updateQuoteStartId: (state, action: PayloadAction<AnalyticsQuoteIdType>) => {
      state.goalIdentifiers.quoteStartId = action.payload.quoteStartId;
    },
    updateIndicateQuoteId: (state, action: PayloadAction<AnalyticsQuoteIdType>) => {
      state.goalIdentifiers.indicativeQuoteId = action.payload.indicativeQuoteId;
    },
    updateQuoteCompleteId: (state, action: PayloadAction<AnalyticsQuoteIdType>) => {
      state.goalIdentifiers.quoteCompleteId = action.payload.quoteCompleteId;
    },
    updateBuyCompleteId: (state, action: PayloadAction<AnalyticsQuoteIdType>) => {
      state.goalIdentifiers.buyCompleteId = action.payload.buyCompleteId;
    },
    updateSessionExtended: (state, action: PayloadAction<AnalyticsSessionTimeout>) => {
      state.sessionTimeout.sessionExtended = action.payload.sessionExtended;
    },
    updateRetrieveQuoteReachedPayment: (state, action: PayloadAction<AnalyticsRetrieveQuote>) => {
      state.retrieveQuote.reachedPayment = action.payload.reachedPayment;
    },
    updateRetrieveQuoteId: (state, action: PayloadAction<AnalyticsRetrieveQuote>) => {
      state.retrieveQuote.retrieveQuoteId = action.payload.retrieveQuoteId;
    },
    updateRenewalPaymentId: (state, action: PayloadAction<AnalyticsQuoteIdType>) => {
      state.goalIdentifiers.renewalPaymentId = action.payload.renewalPaymentId;
    },
    updatePayMyBillPolicy: (state, action: PayloadAction<GetPolicyResponse>) => {
      state.payMyBill = action.payload;
    },
  },
});

export const {
  updateQuoteStartId,
  updateIndicateQuoteId,
  updateQuoteCompleteId,
  updateBuyCompleteId,
  updateSessionExtended,
  updateRetrieveQuoteReachedPayment,
  updateRetrieveQuoteId,
  updatePayMyBillPolicy,
  updateRenewalPaymentId,
} = trackAnalyticsSlice.actions;
export default trackAnalyticsSlice.reducer;
